export const BACKEND_URL: string =
    (process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000') + '/1.0/';

export const STRIPE_PUBLIC_KEY: string =
    process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
    'pk_test_51QgstbGC1jddR1oek282TLmkik2MLBspCPEUq84BEfHTvLwa7U2HD6j5Z7ctRfhBF2gLjthfVxgNxC06KOM8GcbW00ACeNn11e';

export const MINIMUM_PAYMENT_AMOUNT: number = 100;

export const STATIC_CDN_URL: string =
    process.env.REACT_APP_STATIC_CDN_URL || 'https://images.fire-knife.com';

export const IS_DEVELOPMENT_ENV: boolean = process.env.NODE_ENV !== 'production';
